import { render } from "./CargueBalance.vue?vue&type=template&id=6a78c7e2&scoped=true"
import script from "./CargueBalance.vue?vue&type=script&lang=js"
export * from "./CargueBalance.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./CargueBalance.vue?vue&type=style&index=1&id=6a78c7e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a78c7e2"]])

export default __exports__